import React from 'react';
import { Link } from 'react-router-dom';
import {useSetting} from "../SettingsContext";

const Header = () => {
    const setting = useSetting();
  return (
      <header className="header_area">
          <div className="header-top bg-dark text-white py-2">
              <div className="container">
                  <div className="d-flex align-items-center">
                      <div id="logo">
                          <Link className="nav-link" to="/" >
                            <img style={{width:'250px'}} src="eliteriyadhhotel-removebg-preview.png" alt="" title=""/>
                          </Link>
                      </div>
                      <div className="ml-auto d-none d-md-block d-md-flex">
                          <div className="media header-top-info">
                              <span className="header-top-info__icon"><i className="fas fa-phone-volume"></i></span>
                              <div className="media-body">
                                  <p>Have any question?</p>
                                  <p className='text-white'>Free: <a className='text-white' href="tel:+12 365 5233">{setting?.helpline}</a></p>
                              </div>
                          </div>
                          <div className="media header-top-info">
                              <span className="header-top-info__icon"><i className="ti-email"></i></span>
                              <div className="media-body">
                                  <p>Have any question?</p>
                                  <p>Free: <a className='text-white' href="tel:+12 365 5233">{setting?.email}</a></p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="main_menu">
              <nav className="navbar navbar-expand-lg navbar-light">
                  <div className="container">
                      <button className="navbar-toggler" type="button" data-toggle="collapse"
                              data-target="#navbarSupportedContent"
                              aria-controls="navbarSupportedContent" aria-expanded="false"
                              aria-label="Toggle navigation">
                          <span className="icon-bar"></span>
                          <span className="icon-bar"></span>
                          <span className="icon-bar"></span>
                      </button>

                      <div className="collapse navbar-collapse offset" id="navbarSupportedContent">
                
                          <ul className="nav navbar-nav menu_nav">
                              <li className="nav-item active">
                                  <Link className="nav-link" to="/" >Home</Link>
                              </li>
                              <li className="nav-item">
                                  <Link className="nav-link" to="/room" >Rooms</Link>
                              </li>
                              <li className="nav-item">
                                  <Link className="nav-link" to="/restaurant" >Restaurants</Link>
                              </li>
                              <li className="nav-item">
                                  <Link className="nav-link" to="/super-shop" >Shop</Link>
                              </li>
                              <li className="nav-item">
                                  <Link className="nav-link" to="/faq" >Faq's</Link>
                              </li>
                              <li className="nav-item submenu dropdown">
                                <Link className="nav-link" to="/blog" >Blog</Link>
                              </li>
                              <li className="nav-item">
                                  <Link className="nav-link" to="/about" >About</Link>
                              </li>
                              <li className="nav-item">
                              <Link className="nav-link" to="/contact" >Contact</Link>
                                </li>
                          </ul>
                      </div>

                      <ul className="social-icons ml-auto">
                          <li><a href={setting?.facebook}><i className="fab fa-facebook-f"></i></a></li>
                          <li><a href={setting?.linkedin}><i className="fab fa-linkedin-in"></i></a></li>
                          <li><a href={setting?.twitter}><i className="fab fa-twitter"></i></a></li>
                          <li><a href={setting?.google_plus}><i className="fab fa-google-plus-g"></i></a></li>
                          <li><a href={setting?.youtube}><i className="fab fa-youtube"></i></a></li>
                      </ul>
                  </div>
              </nav>
          </div>
      </header>
  );
};

export default Header;